import { ToastService } from 'src/app/services/toast.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha-2';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user_V2.service';
import { ThemeService } from 'src/app/services/theme.service'
import { AppConfigService } from 'src/app/app-config.service.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-register-cubeshop-user',
    templateUrl: './register-cubeshop-user.component.html',
    styleUrls: ['./register-cubeshop-user.component.scss'],
    standalone: false
})
export class RegisterCubeShopUserComponent implements OnInit, OnDestroy {

  formProgressReport: UntypedFormGroup = new UntypedFormGroup({
    firstname: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    lastname: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    email: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
  });

  ecomerceconcode: any;

  // formRegister = {
  //   firstname: '',
  //   lastname: '',
  //   email: '',
  // }

  hasproject: any;
  mycatchaResponse: any;  
  firstRegister = false;
  ready = false
  base64Logo: any
  hasCompanyLogo = false;  // true si la URL trajo logo propio de la empresa (white-label)
  submitted = false;
  isLoading = false;

  public resolved(captchaResponse: string): void {
    this.mycatchaResponse = captchaResponse;
  }

  public onError(errorDetails: string): void {
  }  
  
  constructor(private fb: UntypedFormBuilder, private route: ActivatedRoute, private appConfigService: AppConfigService, public userService: UserService, private toast: ToastService, private router: Router, public ThemeService: ThemeService, private meta: Meta) {

    
    
      
  }

    ngOnDestroy() {
      this.meta.removeTag("name='robots'");
    }

    ngOnInit() {
      this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    this.ThemeService.setNavaBar('navbar-disabled')

    // el logo lo deja cargado /login; si se entra directo a esta ruta viene vacio (antes se veia

    // la imagen rota) => se usa la marca de CUBE

    const logo = this.ThemeService.getImgLogo();

    this.hasCompanyLogo = typeof logo === 'string' && logo.startsWith('data:');

    this.base64Logo = this.hasCompanyLogo ? logo : 'assets/cube-logo.png';
    this.ecomerceconcode = this.ThemeService.getEcomerceconcode();
      
      // this.formProgressReport = this.fb.group(
      //   {
      //     firstname: ['', Validators.required],
      //     lastname: ['', [Validators.required]],
      //     email: ['', [Validators.required]]
      //   }
      // )

      this.initForm()
      // this.formProgressReport = new FormGroup({
      //   firstname: new FormControl({ value: '', disabled: false }, [Validators.required]),
      //   lastname: new FormControl({ value: '', disabled: false }, [Validators.required]),
      //   email: new FormControl({ value: '', disabled: false }, [Validators.required]),
      // });
    }

    initForm(){
      this.formProgressReport = new UntypedFormGroup({
        companyname: new UntypedFormControl({ value: null, disabled: false }, [Validators.required]),
        firstname: new UntypedFormControl({ value: null, disabled: false }, [Validators.required]),
        lastname: new UntypedFormControl({ value: null, disabled: false }, [Validators.required]),
        email: new UntypedFormControl({ value: null, disabled: false }, [Validators.required, Validators.email]),
      });
    }

    goLogin(){
      this.router.navigateByUrl('/login');   
    }

    saveUser(){
      // primero los campos (errores inline debajo de cada uno), despues el captcha
      this.submitted = true;
      if (this.formProgressReport.invalid) {
        return 0;
      }
      if (!this.mycatchaResponse){
        this.toast.error('You must resolve catcha.');
        return 0;
      }
      let form = this.formProgressReport.value;
      form.captchacode = this.mycatchaResponse;

      if (!form.firstname || !form.lastname || !form.email ||!form.companyname){
        this.toast.error('All fields are necessary.');
        return 0;
      }

      if (!environment.production) { console.log(this.formProgressReport); }

      form.conncode = this.ecomerceconcode;

      this.isLoading = true;
      this.userService.insertExtUsr(form).subscribe(result => {
        this.isLoading = false;
        if (!environment.production) { console.log(result); }
        if (result[0].response == -2){
          this.viewEmail2 = true
        }
        else {
          this.viewEmail = true
        }
      }, () => {
        this.isLoading = false;
        this.toast.error('An error has occurred, please try again.');
      })
    }
    viewEmail2 = false
    viewEmail = false
    okClick(){
      this.viewEmail = false
      this.router.navigateByUrl('/login'); 
    }

}
